import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON, isOk, authReq, getUrlParams, getToken} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function usersSave(users) {
  return {
    type: constants.USERS_SAVE,
    users
  };
}

export function usersModalOpen(user) {
	return {
		type: constants.USERS_MODAL_OPEN,
		user
	}
}

export function usersModalClose() {
	return {
		type: constants.USERS_MODAL_CLOSE,
	}
}

export function setCustomerCard(card) {
	return {
		type: constants.USERS_SET_CUSTOMER_CARD,
		card
	}
}

export function usersSetSelf(user) {
	return {
		type: constants.USERS_SET_SELF,
		user
	}
}

export function usersAddToShareQueue(diamonds, page = null) {
	return {
		type: constants.USERS_ADD_TO_SHARE_QUEUE,
		diamonds,
		page
	}
}

export function usersSetReturnTo(page) {
	return {
		type: constants.USERS_RETURN_TO,
		page
	}
}


export function setCustomerCardToEdit(card) {
	return {
		type: constants.USERS_CARD_TO_EDIT,
		card
	}
}

export function fetchUserDirectoryPending(payload) {
	return {
		type: constants.USERS_FETCH_DIRECTORY_PENDING,
		payload
	}
}


/******************************
*******  Asynchronous  ********
******************************/

export function fetchUsers() {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_FETCH;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchSelf() {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_FETCH_SELF;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function userSave(userData) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_SAVE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(userData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function userDelete(userData) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_DELETE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(userData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userSaveCustomerCardRequest(cardData) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_SAVE_CARD;
		return fetch(url, {
		  method: 'post',
		  headers: api.HEADERS,
		  body: JSON.stringify(cardData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userCustomerCreate(cardData) {
	return async dispatch => {
		let url = api.CUSTOMER_API_URL + endpoint.USERS_CUSTOMERS_CREATE;
		return fetch(url, {
		  method: 'post',
		  headers: api.HEADERS,
		  body: JSON.stringify(cardData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userCustomerUpdate(cardData) {
	return async dispatch => {
		let url = api.CUSTOMER_API_URL + endpoint.USERS_CUSTOMERS_UPDATE + cardData.id;
		return fetch(url, {
		  method: 'put',
		  headers: api.HEADERS,
		  body: JSON.stringify(cardData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userCustomerFetchNotes(customerId) {
	return async dispatch => {
		let url = api.CUSTOMER_API_URL + endpoint.USERS_CUSTOMERS_NOTES + getUrlParams({ at: getToken(), id: customerId });
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS,
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userCustomerAddNote(customerId, noteData) {
	return async (dispatch, getState) => {

		let url = api.CUSTOMER_API_URL + endpoint.USERS_CUSTOMERS_NOTES_ADD + getUrlParams({ at: getToken(), id: customerId });
		return fetch(url, {
		  method: 'post',
		  headers: api.HEADERS,
		  body: JSON.stringify(noteData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function fetchUserDirectory() {
	return (dispatch, getState) => {

		if(getState().users.pendingFetchDirectory) {
			return Promise.reject(null);
		}
		dispatch(fetchUserDirectoryPending(true));

		let url = api.API_URL + endpoint.USERS_FETCH_DIRECTORY;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {

			dispatch(fetchUserDirectoryPending(false));
			
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function usersAdminPasswordReset(resetData) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_ADMIN_PASSWORD_RESET;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(resetData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userValidatePassword(passwordData) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_VALIDATE_PASSWORD;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(passwordData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userNotesFetch(customerNumber) {
	return dispatch => {
		let url = api.API_URL + endpoint.NOTES_FETCH + '?customer_number=' + customerNumber;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userNotesCreate(notesData) {
	return dispatch => {
		let url = api.API_URL + endpoint.NOTES_CREATE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(notesData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userNotesEdit(notesData) {
	return dispatch => {
		let url = api.API_URL + endpoint.NOTES_EDIT;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(notesData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}


export function userNotesDelete(notesData) {
	return dispatch => {
		let url = api.API_URL + endpoint.NOTES_DELETE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(notesData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}



export function userCardDiamondsFetch(cardId) {
	return dispatch => {
		let url = api.API_URL + endpoint.USERS_CARD_DIAMONDS_FETCH + '?card_id=' + cardId;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

